<div class="view-button-container">
  <button *ngFor="let view of views.filter(isView)" class="branding-button"
          type="button"
          (click)="changeCamera.next(view.position)"
          class="canvas-view">
    <svg class="button-icon">
      <use [attr.xlink:href]="'/assets/images/' + view.position + '.svg#' + view.position"></use>
    </svg>
  </button>
</div>
